import { useQuery } from "@tanstack/react-query";
import { motion, useReducedMotion } from "framer-motion";
import { api } from "../../api";
import { TRAINER } from "../../constants/testIds";
import { fadeUp } from "../../lib/motion";
import { GymLoader } from "../../components/common/GymLoader";

// UX-TR-01 §1 SCR-P06-31: a deterministic, this-trainer-only read-model computed server-side
// from the same real bookings/retention data every other screen uses — no fabricated ratings.
export default function Performance() {
  const reducedMotion = useReducedMotion();
  const perfQ = useQuery({ queryKey: ["trainer-performance"], queryFn: async () => (await api.get("/trainer/performance")).data });

  if (perfQ.isLoading) return <GymLoader fullPage label="Loading performance…" testId="trainer-performance-loader" />;
  const d = perfQ.data;

  const cards = [
    { key: "sessions", label: "Sessions delivered", value: d?.total_sessions_delivered, testId: TRAINER.performanceSessionsStat, color: "var(--scarlet-pos)" },
    { key: "noshow", label: "No-shows", value: d?.total_no_shows, testId: TRAINER.performanceNoShowStat, color: "var(--scarlet-neg)" },
    { key: "rebooking", label: "Rebooking rate", value: d?.rebooking_rate != null ? `${Math.round(d.rebooking_rate * 100)}%` : "—", testId: TRAINER.performanceRebookingStat, color: "#141416" },
    { key: "atrisk", label: "Clients at risk", value: d?.clients_at_risk, testId: TRAINER.performanceAtRiskStat, color: "var(--scarlet-neg)" },
  ];

  return (
    <div data-testid={TRAINER.performancePage} className="space-y-6 max-w-2xl">
      <motion.div {...fadeUp(reducedMotion)}>
        <h1 className="text-2xl font-bold" style={{ color: "#141416" }}>My performance</h1>
        <p className="text-sm mt-0.5" style={{ color: "#68686E" }}>Based on your own real sessions and clients only.</p>
      </motion.div>

      <div className="grid grid-cols-2 gap-4">
        {cards.map((c, i) => (
          <motion.div key={c.key} {...fadeUp(reducedMotion, 0.03 * (i + 1))} className="rounded-[14px] p-5" style={{ background: "#fff", border: "1px solid #EBEAE5" }}>
            <p className="eyebrow">{c.label}</p>
            <p data-testid={c.testId} className="text-2xl font-bold mt-1 tabular-nums-force" style={{ color: c.color }}>{c.value ?? "—"}</p>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
